









































import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "welcome-component",
})
export default class WelcomeComponent extends Vue {
  get active(): boolean {
    return this.$store.getters["SystemStore/getShowWelcome"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowWelcomeAction", false);
  }
  get user(): UserInterface {
    return this.$store.getters["UserStore/getUser"];
  }
  onClose(): void {
    this.$store.dispatch("SystemStore/setShowWelcomeAction", false);
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", true);
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
}
